import * as pt from "@cicada-lang/partech";
import {} from "../../exp/index.js";
import * as matchers from "../matchers/index.js";
export function exp_matcher(tree) {
    return pt.matcher({
        "exp:operator": ({ operator }) => operator_matcher(operator),
        "exp:operand": ({ operand }) => operand_matcher(operand),
    })(tree);
}
export function operator_matcher(tree) {
    return pt.matcher({
        "operator:var": ({ name }, { span }) => ({
            "@type": "Exp",
            "@kind": "Var",
            name: pt.str(name),
            span,
        }),
        "operator:builtin": ({ name }, { span }) => ({
            "@type": "Exp",
            "@kind": "Builtin",
            name: pt.str(name),
            span,
        }),
    })(tree);
}
export function operand_matcher(tree) {
    return pt.matcher({
        "operand:ap": ({ target, args }, { span }) => ({
            "@type": "Exp",
            "@kind": "Ap",
            target: operator_matcher(target),
            args: matchers.args_matcher(args),
            span,
        }),
        "operand:ap_nullary": ({ target }, { span }) => ({
            "@type": "Exp",
            "@kind": "Ap",
            target: operator_matcher(target),
            args: [],
            span,
        }),
        "operand:quote_symbol": ({ name }, { span }) => ({
            "@type": "Exp",
            "@kind": "QuoteSymbol",
            name: pt.str(name),
            span,
        }),
        "operand:block": ({ body }, { span }) => ({
            "@type": "Exp",
            "@kind": "Block",
            body: matchers.block_stmts_matcher(body),
            span,
        }),
    })(tree);
}
//# sourceMappingURL=exp_matcher.js.map